import HTTP from './http'
const BASE_URL = '/metrics'

export default {
  /**
   * Get a list of metrics
   * @param {Boolean} hasMissingDocuments If true, only show carriers with missing uploads
   * @returns {Promise<*>}
   */
  /**
   * Get a list of metrics based on the given companyKey or accountKey
   * @param {String} companyKey
   * @param {String}  accountKey
   * @returns {Promise<*>}
   */
  async list({ companyKey, accountKey, period } = {}) {
    const params = {
      companyKey,
      accountKey,
      period
    }
    const response = await HTTP.get(`${BASE_URL}`, { params })
    return response.data.data
  }
}
